export default "__VITE_ASSET__Do6NmwRg__"